import apiClient from "./api";
const LABORATORIO_API_BASE_URL = "/laboratorios";
class LaboratoriosService {
  getLaboratorios() {
    return apiClient.get(LABORATORIO_API_BASE_URL);
  }
  agregarLaboratorio(laboratorio) {
    return apiClient.post(LABORATORIO_API_BASE_URL, laboratorio);
  }
  updateLaboratorio(laboratorio, laboratorioId) {
    return apiClient.put(LABORATORIO_API_BASE_URL + "/" + laboratorioId, laboratorio);
  }
  deleteLaboratorio(laboratorioId) {
    return apiClient.delete(LABORATORIO_API_BASE_URL + "/" + laboratorioId);
  }
}
export default new LaboratoriosService();